import { IFieldState } from '../store/applicationform/applicationFormTypes';
import { Question } from '../types/KycTypes';

/**
 * Returns if the supplied question should be shown or not based on the current field states.
 *
 * @param question the question to check
 * @param allQuestions  all available questions (even those which are hidden)
 * @param kycAnswerFieldStates the current answers of all questions
 * @returns true if the question should be shown
 */
export const shouldRenderQuestion = (
    question: Question,
    allQuestions: Question[],
    kycAnswerFieldStates: IFieldState[],
) => {
    const hasDisplayCondition = question.displayCondition;
    if (!hasDisplayCondition) {
        return true;
    }
    const questionPrefix = 'KYC_' + question.groupId + '_';

    const requiredFieldName = questionPrefix + question.displayCondition!.questionId;
    const requiredQuestion = allQuestions.find((s) => question.displayCondition!.questionId === s.name);
    const requiredAnswerOption = requiredQuestion?.options?.find((q) => q.id === question.displayCondition?.optionId);

    const requiredAnswerValue = requiredAnswerOption?.label;
    const currentAnswer = kycAnswerFieldStates.find((f) => f.fieldName === requiredFieldName)?.value ?? undefined;

    if (Array.isArray(currentAnswer)) {
        return currentAnswer.indexOf('' + requiredAnswerValue) > -1;
    }
    return '' + requiredAnswerValue === currentAnswer;
};
